import { useEffect, useRef } from "react";

export default function ClickSound() {
  const audioRef = useRef(null);

  useEffect(() => {
    // Create audio element
    audioRef.current = new Audio("https://customer-assets.emergentagent.com/job_purple-portfolio-16/artifacts/ehw6yp7k_Valhalla%20-%20GamePlay.mp4");
    audioRef.current.volume = 0.3;

    const handleMouseDown = () => {
      if (audioRef.current) {
        // Reset to start if already playing
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {
          // Ignore autoplay errors
        });
      }
    };

    // Add listener to document for all clicks
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);

  return null;
}
